module.exports = __webpack_public_path__ + "img/tooth_kepler.b5523583.svg";